import CloseOutlined from '@ant-design/icons/CloseOutlined';
import css from './input.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFHeaderSearchForSearch from '@/components/UI/svg/Header/Icon/EFHeaderSearchForSearch';
type params = {
    value?: string;
    className?: any;
    defaultValue?: string;
    placeholder?: string;
    list?: any[];
    autoFilter?: boolean;
    fieldNames?: { label: string; value: string; options?: string };
    allowClear?: boolean;
    onChange?: (value: string) => void;
    onSelect?: (value?: any, name?: any, option?: any) => void;
    onInputKeyDown?: (e?: any) => void;
    onClear?: () => void;
    onFocus?: () => void;
    onBlur?: () => void;
    dorpDownDesc?: string;
};
export default function SearchDrop(params: params) {
    const {
        value = '',
        className,
        defaultValue = '',
        placeholder,
        list = [],
        autoFilter,
        fieldNames = { label: 'label', value: 'value', options: 'options' },
        allowClear = false,
        onSelect = () => {},
        onChange = () => {},
        onInputKeyDown = () => {},
        onClear = () => {},
        onFocus = () => {},
        onBlur = () => {},
        dorpDownDesc,
    } = params;
    const { useState, useEffect, useRef } = useGlobal();
    const [open, setOpen] = useState(false);
    const [selectKey, setSelectKey] = useState();
    const [inputValue, setInputValue] = useState(defaultValue);
    const [recommendList, setRecommendList] = useState(list);
    const ref = useRef();
    const handleInputChange = (e: any) => {
        const value = e.target.value;
        setInputValue(value);
        onChange(value);
    };

    const handleKeyDown = (e: any) => {
        if (e.keyCode === 13) {
            setOpen(false);
        }
        onInputKeyDown(e);
    };

    const handleClickItem = (value: any, name: any, option: any) => {
        onSelect(value, name, option);
        setSelectKey(value);
        setInputValue(value);
        setOpen(false);
    };

    const handleFocus = () => {
        setOpen(true);
        onFocus();
    };

    const handleBlur = () => {
        onBlur();
    };

    const handleClear = () => {
        setSelectKey(null);
        setInputValue('');
        onClear();
    };

    const onMouseup = (e: MouseEvent) => {
        const searchDom = ref.current;
        if (searchDom) {
            if (!searchDom.contains(e.target)) {
                setOpen(false);
            }
        }
    };

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    useEffect(() => {
        autoFilter &&
            setRecommendList(
                list.filter((item) => {
                    const label_lowercase = item[fieldNames.label]?.toLocaleLowerCase() || '';
                    const value_lowercase = inputValue?.toLocaleLowerCase() || '';
                    if (!value_lowercase) return true;
                    return label_lowercase.indexOf(value_lowercase) > -1;
                }),
            );
    }, [inputValue]);

    useEffect(() => {
        document.addEventListener('mouseup', onMouseup);
        return () => {
            document.removeEventListener('mouseup', onMouseup);
        };
    });
    return (
        <div className={`${css.SearchDrop} ${className || ''}`} ref={ref}>
            <div className="input-wrapper">
                <input
                    // autoFocus
                    value={inputValue}
                    type="text"
                    className="search-input"
                    placeholder={placeholder}
                    aria-label={placeholder}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
                <span className="searchIcon">
                    <EFHeaderSearchForSearch />
                </span>
                {allowClear && !!inputValue && (
                    <span onClick={handleClear} className="closeIcon">
                        <CloseOutlined style={{ color: '#fff' }} />
                    </span>
                )}
            </div>

            <div className={`drop-down-wrapper ${open ? 'drop-open' : ''}`}>
                <div className="padding" />
                <div className="drop-down">
                    <p className="recommend">{dorpDownDesc}</p>
                    <div className="drop-down-list">
                        {recommendList?.map((item: any, index: number) => (
                            <div
                                key={item[fieldNames.value] + index}
                                className={`drop-down-item ${selectKey === item[fieldNames.value] ? 'select-item' : ''}`}
                                onClick={() => handleClickItem(item[fieldNames.value], item[fieldNames.label], item)}
                            >
                                {item[fieldNames.label]}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
